import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, Target, Clock, Layers } from "lucide-react";
import { Button } from "@/components/ui/button";

const IMG = "https://images.pexels.com/photos/7433874/pexels-photo-7433874.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export default function About() {
  const navigate = useNavigate();
  return (
    <div>
      <section className="border-b border-edge grain-bg">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
          <div className="eyebrow mb-3">About BullsEye Capital</div>
          <h1 className="h-display text-4xl sm:text-5xl lg:text-6xl text-white max-w-3xl">Built for real estate operators.</h1>
          <p className="mt-5 text-base sm:text-lg text-dim max-w-2xl leading-relaxed">
            BullsEye Capital understands investment transactions. We focus on financing for investment and
            business-purpose real estate — structured around the deal.
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16 grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <div className="space-y-6">
            {[
              { icon: Clock, t: "Time-sensitive by nature", d: "Real estate investors often deal with time-sensitive opportunities. We work to keep transactions moving." },
              { icon: Layers, t: "Different deals, different structures", d: "Different deals require different financing structures. We help investors access financing across multiple investment strategies." },
              { icon: Target, t: "Investment-focused", d: "The company is focused on investment and business-purpose real estate transactions — not consumer mortgages." },
            ].map((x, i) => (
              <div key={i} className="flex gap-4" data-testid={`about-point-${i}`}>
                <div className="w-11 h-11 icon-chip shrink-0"><x.icon className="w-5 h-5 text-gold" strokeWidth={1.7} /></div>
                <div>
                  <h3 className="text-lg font-bold text-white">{x.t}</h3>
                  <p className="mt-1 text-sm text-dim leading-relaxed">{x.d}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="relative rounded-2xl overflow-hidden border border-edge">
          <img src={IMG} alt="BullsEye Capital deal desk" className="w-full h-full object-cover" />
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 pb-16">
        <div className="card-rich p-8 grid md:grid-cols-[1fr_auto] gap-8 items-center">
          <div>
            <div className="eyebrow mb-3">Meet Archer · Powered by BullsEye technology</div>
            <p className="text-dim leading-relaxed max-w-2xl">
              Archer embodies how BullsEye Capital operates — precise and relentless. Behind the scenes, we use
              technology-assisted workflows to organize transactions, collect documents, and streamline financing
              requests. The larger BullsEye technology platform is developed separately.
            </p>
          </div>
          <img src="/archer.png" alt="Archer — BullsEye Capital" className="hidden md:block h-56 w-auto justify-self-center drop-shadow-[0_20px_40px_rgba(0,0,0,0.5)]" />
        </div>

        <div className="mt-10 rounded-2xl border border-gold/30 bg-gold/5 p-8 sm:p-10 text-center">
          <h3 className="h-display text-2xl sm:text-3xl text-white">You found the deal. <span className="gold-text italic">We fund it.</span></h3>
          <Button onClick={() => navigate("/apply")} className="btn-gold rounded-full h-14 px-8 mt-5 gap-2">Apply for Financing <ArrowRight className="w-5 h-5" /></Button>
        </div>
      </section>
    </div>
  );
}
